import { defineQuiz } from "./_schema";
import { cortisolQuiz } from "./cortisol";

/**
 * CORTISOL-QUIZ-X -- tracking-isolated duplicate of the cortisol quiz for
 * X (Twitter) traffic.
 *
 * Analytics in this system is keyed by SLUG, not URL (admin funnel,
 * quiz_submissions.quiz_slug, Klaviyo event/profile props). X-sourced traffic
 * to the cortisol funnel needs to be attributable separately, so we mount an
 * identical quiz under a distinct slug and publish it at
 * /pages/cortisol-quiz-x. Same on-screen experience, separate row everywhere
 * in our own analytics. Mirrors the cortisol-quiz-al / cortisol-quiz-gl
 * pattern.
 *
 * This is a THIN RE-EXPORT of cortisol: it spreads `cortisolQuiz` and overrides
 * only `id` / `slug`. The two quizzes share the same `questions` array,
 * `branching`, `classifier`, and `deriveProfile` (deriveCortisolProfile, with
 * its cortisol-dominance forced-Primary seam) BY REFERENCE, so they can never
 * drift -- any future edit to cortisol's content or deriver propagates here
 * automatically. If the two are ever meant to diverge, that becomes a
 * deliberate change (stop spreading, fork the fields).
 *
 * Unlike quiz-v6-x, there is no Intelligems `experiment` to drop -- the
 * cortisol quiz never carried one.
 *
 * See docs/specs/2026-08-20-x-tracking-duplicates-design.md.
 */
export const cortisolQuizXQuiz = defineQuiz({
  ...cortisolQuiz,
  id: "cortisol-quiz-x",
  slug: "cortisol-quiz-x",
});
